function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "price-tag");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.388 0.405c-0.111-0.314-0.454-0.48-0.769-0.371s-0.481 0.455-0.372 0.77c0.929 2.67-0.915 4.664-2.321 5.732l-0.568-0.814c-0.191-0.273-0.618-0.5-0.95-0.504l-3.188 0.014c-0.332-0.006-0.825 0.146-1.097 0.338l-9.394 6.587c-0.455 0.32-0.565 0.947-0.247 1.404l4.269 6.108c0.32 0.455 0.831 0.4 1.287 0.082l9.394-6.588c0.27-0.191 0.582-0.603 0.692-0.918l0.998-3.145c0.11-0.314 0.043-0.793-0.148-1.066l-0.346-0.496c1.888-1.447 3.848-4.004 2.76-7.133zM15.017 9.763c-0.727 0.51-1.731 0.332-2.24-0.396-0.511-0.73-0.333-1.734 0.395-2.246 0.578-0.405 1.328-0.376 1.868 0.017-0.272 0.164-0.459 0.26-0.494 0.275-0.301 0.143-0.43 0.504-0.288 0.805 0.104 0.219 0.321 0.348 0.547 0.348 0.086 0 0.174-0.020 0.257-0.059 0.194-0.092 0.402-0.201 0.619-0.33 0.097 0.594-0.139 1.217-0.664 1.586z"
});

var SvgPriceTag = function SvgPriceTag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPriceTag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/price-tag.cc81829a.svg";
export { ForwardRef as ReactComponent };